import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Florida Blue Marketplace",
  shortName: "Florida Blue Marketplace",
  slug: "florida-blue-marketplace-insurance",
  seoTitle: "Florida Blue Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have a Florida Blue Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Florida Blue Marketplace TMS coverage, Florida Blue TMS therapy, Florida Blue ACA depression treatment, Florida Blue Marketplace mental health benefits, Florida Blue SAINT TMS",
  planType:
    "Health Insurance Marketplace plan (ACA / Healthcare.gov, BCBS affiliate)",
  planRegion: "Florida",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "Florida Blue, an independent licensee of the Blue Cross Blue Shield Association, offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov). These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Florida Blue Marketplace plans come in different metal tiers — Bronze, Silver, Gold, and Platinum — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl:
    "https://www.floridablue.com/individuals-families/shop-for-plans",
  officialResourceLabel: "Florida Blue Marketplace plans",
};

export const FloridaBlueMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default FloridaBlueMarketplaceInsurance;
